import {
  MessageSquare, BarChart3, TrendingUp 
} from 'lucide-react';
import type { FeedbackType } from '@/features/performance';

export const TABS = [
  {
    id: 'feedback',
    label: 'Feedback',
    href: '/performance/feedback',
    icon: MessageSquare,
  },
  {
    id: 'reviews',
    label: 'Reviews',
    href: '/performance/reviews',
    icon: BarChart3,
  },
  {
    id: 'goals',
    label: 'Goals',
    href: '/performance/goals',
    icon: TrendingUp,
  },
] as const;

export type TabId = 'feedback' | 'reviews' | 'goals';

export const FEEDBACK_TYPES: {
  value: FeedbackType;
  label: string 
}[] = [
  {
    value: 'praise',
    label: 'Praise' 
  },
  {
    value: 'improvement',
    label: 'Improvement' 
  },
  {
    value: 'coaching',
    label: 'Coaching' 
  },
  {
    value: 'recognition',
    label: 'Recognition' 
  },
];

export const CATEGORIES = [
  {
    value: 'Food Quality',
    label: 'Food Quality' 
  },
  {
    value: 'Inventory Management',
    label: 'Inventory Management' 
  },
  {
    value: 'Quality Control',
    label: 'Quality Control' 
  },
  {
    value: 'Communication',
    label: 'Communication' 
  },
  {
    value: 'Teamwork',
    label: 'Teamwork' 
  },
  {
    value: 'Safety',
    label: 'Safety' 
  },
  {
    value: 'Customer Service',
    label: 'Customer Service' 
  },
];

export const RATING_OPTIONS = [
  {
    value: '1',
    label: '1 - Needs Improvement' 
  },
  {
    value: '2',
    label: '2 - Below Expectations' 
  },
  {
    value: '3',
    label: '3 - Meets Expectations' 
  },
  {
    value: '4',
    label: '4 - Exceeds Expectations' 
  },
  {
    value: '5',
    label: '5 - Outstanding' 
  },
];
